export const environmentConfig = {
  screenAllowed: 1,
  restrictedAppsWin: [
    'msedge',
    'firefox',
    'zoom',
    'google-meet',
    'slack',
    'brave',
    'AnyDesk',
    'chrome',
    'Teams',
    'Zoom',
    'ms-teams',
    'skype',
    'teamviewer',
    'ciscocollabhost',
    'goto',
    'obs64',
    'obs32',
    'discord',
    'ultraviewer_desktop',
    'remotepcuiu',
    'Leetcode Wizard',
    'cluely',
    'Interview Coder',
    'ChatGPT',
    'ParakeetAI',
    'ShadeCoder',
    'SnippingTool',
    'ScreenSketch',
    'GameBar',
    'Greenshot',
    'Lightshot',
    'ShareX',
    'SnagIt',
    'Bandicam',
    'CamtasiaStudio',
    'Screenpresso',
    'UltraViewer_Desktop',
    'UltraViewer_Service',
  ],

  restrictedAppsLinux: [
    'firefox',
    'teams',
    'zoom',
    'google-meet',
    'slack',
    'anydesk',
    'chrome',
    'brave',
    'bash',
    'cron',
  ],
  killAppsLinux: [
    'firefox',
    'teams',
    'zoom',
    'google-meet',
    'slack',
    'anydesk',
    'chrome',
    'brave',
    'gnome-screenshot',
    'flameshot',
    'shutter',
    'obs',
    'simplescreenrecorder',
    'obs64',
    'obs32',
  ],
  restrictedAppsMacOS: [
    'Safari', // w
    'firefox', // w
    '"Google Chrome"', // w
    '"Microsoft Edge"', // w
    'Opera', // w
    '"Brave Browser"', // w
    'Zoom',
    'zoom.us', // w
    '"Join for Zoom Meetings"', // w
    '"Microsoft Teams"',
    'Skype',
    'FaceTime', // w
    'Slack', // w
    'WhatsApp', // w
    'AnyDesk', // w
    'Terminal', // w
    '"Microsoft Outlook"', // w
    'ShadeCoder',
    'ParakeetAI',
    '"Leetcode Wizard"',
    '"Interview Coder"',
    '"Interview Coder"',
    'cluely',
    'ChatGPT',
    'screencapture',
    'screencaptureui',
    '"QuickTime Player"',
    'ScreenCaptureAgent',
    'obs64',
    'obs32',
  ],
};

export function buildGetRunningProcessWinCommand(
  config = environmentConfig.restrictedAppsWin
) {
  const processes = config.map(name => `'${name}'`).join(', ');
  return `powershell -command "$runningProcesses = Get-Process -Name ${processes} -ErrorAction SilentlyContinue; $runningProcesses | Select-Object -Property Name  | ConvertTo-Csv -NoTypeInformation"`;
  // return `ps -A -o pid,comm | grep chrome `;
}
export function buildFallbackGetRunningProcessWinCommand(
  config = environmentConfig.restrictedAppsWin
) {
  const processes = config.map(name => `${name}`).join(' ');
  return `for /f "tokens=1 delims=," %A in ('tasklist /fo csv ^| findstr /i "${processes}"') do @echo %A`;
}
export function buildGetRunningProcessLinuxOrMacCommand(
  config = environmentConfig.restrictedAppsLinux
) {
  const processes = config.join(' ');

  const t = `for process in ${processes}; 
            do 
                pgrep -x "$process" > /dev/null 2>&1 && echo "$process"; 
            done
`;
  return t;
}
export function buildKillRunningProcessWinCommand(
  config = environmentConfig.restrictedAppsWin
) {
  const processes = config.map(name => `'${name}'`).join(', ');
  return `powershell -command "Stop-Process -Name ${processes} -Force -ErrorAction SilentlyContinue"`;
}
export function buildKillRunningProcessLinuxCommand(
  config = environmentConfig.killAppsLinux
) {
  const processes = config.join(' ');
  const t = `for process in ${processes}; 
            do 
                pkill -x "$process" 
            done
`;

  return t;
}
export function buildKillRunningProcessMacOSCommand(
  killAppsMacOS = environmentConfig.restrictedAppsMacOS
) {
  // Join the apps into a space-separated string
  const processes = killAppsMacOS.join(' ');

  // Create the pkill command for regular and force kill processes
  const regularKillCommand = `for process in ${processes}; do pkill -f "$process"; done`;

  return regularKillCommand;
}

// This function parses the system profiler output for displays
const parseMonitorInfoMacOS = output => {
  // Split the output to parse display and mirroring status
  const outputParts = output.split('\n');

  // Parse Display Information
  const displayInfo = outputParts.filter(
    line => line.includes('Resolution') || line.includes('Display')
  );
  const numberOfMonitors = displayInfo.filter(line =>
    line.includes('Resolution')
  ).length;

  // Parse Mirroring Information
  // const isMirroringEnabled = outputParts.some(line =>
  //   line.includes('Mirror: On')
  // );
  return numberOfMonitors;
};

export const SECURE_BROWER_META = {
  WINDOWS: {
    ACTIONS: {
      NOTIFICATION_CHECK: {
        cmd: `reg query "HKCU\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\PushNotifications" /v ToastEnabled`,
        parsingFn: data => {
          /* eslint-disable */
          const arr = data.split('\r');
          let toastEnabledValue = arr.find(item =>
            item.includes('ToastEnabled')
          );

          if (toastEnabledValue) {
            const parts = toastEnabledValue.trim().split(/\s+/);
            toastEnabledValue = parts[parts.length - 1];
          } else {
            toastEnabledValue = null;
          }
          if (toastEnabledValue) {
            if (toastEnabledValue === '0x0') {
              return false;
            } else if (toastEnabledValue === '0x1') {
              return true;
            } else {
              return true;
            }
          }

          return false;
        },
      },
      MULTI_MONITORS_CHECK: {
        cmd: `powershell -command "Get-PnpDevice -Class monitor -presentOnly | Select-Object Status,Class,FriendlyName"`,
        fallbackCmd: `wmic path Win32_DesktopMonitor get Caption, DeviceID`,
        parsingFn: data => {
          let filteredArr = data.split('\r');

          // Remove all unwanted elements
          filteredArr = filteredArr.filter(
            item => item.trim() !== '' && !item.includes('------')
          );

          // Remove leading and trailing newlines from each string
          filteredArr = filteredArr.map(item => item.trim());
          filteredArr.shift();
          const displayInfo = filteredArr;
          if (displayInfo.length === 1) {
            return false;
          } else {
            return true;
          }
        },
        getMonitorCount: data => {
          let filteredArr = data.split('\r');

          // Remove all unwanted elements
          filteredArr = filteredArr.filter(
            item => item.trim() !== '' && !item.includes('------')
          );

          // Remove leading and trailing newlines from each string
          filteredArr = filteredArr.map(item => item.trim());
          filteredArr.shift();
          return filteredArr.length;
        },
      },
      RUNNING_APP_CHECK: {
        cmd: buildGetRunningProcessWinCommand(),
        fallbackCmd: buildFallbackGetRunningProcessWinCommand(),
        parsingFn: data => {
          const newData = new Set(data.split('\r'));

          const valuesToRemove = ['"Name"', '\n', ''];

          valuesToRemove.forEach(value => {
            newData.delete(value);
          });
          const runningProcess = newData;

          if (runningProcess.size >= 1) {
            return true;
          } else {
            return false;
          }
        },
      },
      KILLING_APP: {
        cmd: buildKillRunningProcessWinCommand(),
        parsingFn: () => {},
      },
      MACHINE_UUID_CHECK: {
        cmd: `wmic csproduct get UUID`,
        parsingFn: data => {
          const lines = data
            .split('\r')
            .map(line => line.trim())
            .filter(line => line && line.toUpperCase() !== 'UUID');
          return lines[0] || null;
        },
      },
      FINGER_GESTURE: {
        cmd: `reg add "HKCU\\Software\\Microsoft\\Windows\\CurrentVersion\\PrecisionTouchPad" /v ThreeFingerSlideEnabled /t REG_DWORD /d 0 /f && reg add "HKCU\\Software\\Microsoft\\Windows\\CurrentVersion\\PrecisionTouchPad" /v FourFingerSlideEnabled /t REG_DWORD /d 0 /f && taskkill /f /im explorer.exe && start explorer.exe`,
        parsingFn: () => {},
      },
      STOP_KEYS_SCRIPT: {
        startScript: 'test2.exe',
        revertScript: 'revert.exe',
      },
    },
  },
  LINUX: {
    ACTIONS: {
      NOTIFICATION_CHECK: {
        cmd: `gsettings get org.gnome.desktop.notifications show-banners`,
        parsingFn: data => {
          /* eslint-disable */
          return data?.includes('true');
        },
      },
      MULTI_MONITORS_CHECK: {
        cmd: `xrandr --listmonitors`,
        parsingFn: data => {
          let filterArr = data.split('\n');
          let numberOfMonitors = 0;
          for (const line of filterArr) {
            if (line.startsWith('Monitors:')) {
              // Extract the number after "Monitors:"
              numberOfMonitors = parseInt(line.split(':')[1].trim());
            }
          }

          return numberOfMonitors >= 2; // Default if no "Monitors:" line is found
        },
        getMonitorCount: data => {
          let filterArr = data.split('\n');
          let numberOfMonitors = 0;
          for (const line of filterArr) {
            if (line.startsWith('Monitors:')) {
              // Extract the number after "Monitors:"
              numberOfMonitors = parseInt(line.split(':')[1].trim());
            }
          }

          return numberOfMonitors; // Default if no "Monitors:" line is found
        },
      },
      RUNNING_APP_CHECK: {
        cmd: buildGetRunningProcessLinuxOrMacCommand(),
        parsingFn: data => {
          const filterArr = data
            .split('\n')
            .filter(arr => !(arr === 'cron' || arr === 'bash' || arr === ''));
          return filterArr.length >= 1;
        },
      },
      KILLING_APP: {
        cmd: buildKillRunningProcessLinuxCommand(),
        parsingFn: () => {},
      },
      MACHINE_UUID_CHECK: {
        cmd: `cat /etc/machine-id`,
        parsingFn: data => data?.trim() || null,
      },
      FINGER_GESTURE: {
        cmd: ``,
        parsingFn: data => {
          // to do
        },
      },
      STOP_KEYS_SCRIPT: {
        startScript: 'test2.xmodmap',
        revertScript: 'setxkbmap',
      },
    },
  },
  MACOS: {
    ACTIONS: {
      NOTIFICATION_CHECK: {
        cmd: `defaults -currentHost read ~/Library/Preferences/ByHost/com.apple.notificationcenterui.plist doNotDisturb`,
        parsingFn: data => {
          // Check the output (stdout)
          const isDNDEnabled = data.trim() === '1'; // true if enabled, false otherwise
          /* eslint-disable */
          return !isDNDEnabled;
        },
      },
      MULTI_MONITORS_CHECK: {
        cmd: `system_profiler SPDisplaysDataType`,
        parsingFn: data => {
          return parseMonitorInfoMacOS(data) >= 2; // Default if no "Monitors:" line is found
        },
        getMonitorCount: data => {
          return parseMonitorInfoMacOS(data); // Default if no "Monitors:" line is found
        },
      },
      RUNNING_APP_CHECK: {
        cmd: buildGetRunningProcessLinuxOrMacCommand(
          environmentConfig.restrictedAppsMacOS
        ),
        parsingFn: data => {
          const filterArr = data
            .split('\n')
            .filter(arr => !(arr === 'cron' || arr === 'bash' || arr === ''));
          return filterArr.length >= 1;
        },
      },
      KILLING_APP: {
        cmd: buildKillRunningProcessMacOSCommand(),
        parsingFn: () => {},
      },
      MACHINE_UUID_CHECK: {
        cmd: `ioreg -rd1 -c IOPlatformExpertDevice`,
        parsingFn: data => {
          const match = data?.match(/"IOPlatformUUID"\s*=\s*"([^"]+)"/);
          return match ? match[1] : null;
        },
      },
      FINGER_GESTURE: {
        cmd: `defaults -currentHost read ~/Library/Preferences/ByHost/com.apple.notificationcenterui.plist doNotDisturb`,
        parsingFn: data => {
          // to do
        },
      },
      STOP_KEYS_SCRIPT: {
        startScript: '',
        revertScript: '',
      },
    },
  },
};

export const SECURE_BROWSER_COMMAND_STATUS = {
  DEFAULT: { result: true, status: 'DEFAULT' },
  INPROGRESS: { result: true, status: 'INPROGRESS' },
  COMPLETED_SUCCESS: {
    result: false,
    status: 'COMPLETED',
  },
  COMPLETED_ERROR: {
    result: true,
    status: 'COMPLETED',
  },
  FAILED: { result: true, status: 'FAILED' },
};

export const isRefreshBtnDisabled = (isOffline, systemCheck) => {
  return (
    [
      systemCheck.isNotificationEnable.status,
      systemCheck.isRestrictedAppsRunning.status,
      systemCheck.multiMonitors.status,
    ].includes('INPROGRESS') || isOffline
  );
};
